import * as React from 'react'

export const TrashIcon = React.memo(({
  className,
  ...props
}) => {
  return (
    <svg
      width='24'
      height='24'
      className={className}
      viewBox='0 0 24 24'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M21 6V19.5C21 21.1569 19.6569 22.5 18 22.5H6.99148C5.33463 22.5 3.99148 21.1569 3.99148 19.5V6.00759H6.37726V20.3442H18.6656V6H21ZM9.5 7.25C9.91421 7.25 10.25 7.58579 10.25 8V17.5C10.25 17.9142 9.91421 18.25 9.5 18.25C9.08579 18.25 8.75 17.9142 8.75 17.5V8C8.75 7.58579 9.08579 7.25 9.5 7.25ZM12.5 7.25C12.9142 7.25 13.25 7.58579 13.25 8V17.5C13.25 17.9142 12.9142 18.25 12.5 18.25C12.0858 18.25 11.75 17.9142 11.75 17.5V8C11.75 7.58579 12.0858 7.25 12.5 7.25ZM15.5 7.25C15.9142 7.25 16.25 7.58579 16.25 8V17.5C16.25 17.9142 15.9142 18.25 15.5 18.25C15.0858 18.25 14.75 17.9142 14.75 17.5V8C14.75 7.58579 15.0858 7.25 15.5 7.25ZM12.5 1.5C13.6192 1.5 14.5666 2.23546 14.8854 3.24946L21.5 3.25C21.9142 3.25 22.25 3.58579 22.25 4C22.25 4.41421 21.9142 4.75 21.5 4.75H3.5C3.08579 4.75 2.75 4.41421 2.75 4C2.75 3.58579 3.08579 3.25 3.5 3.25L10.1146 3.24946C10.4333 2.23546 11.3808 1.5 12.5 1.5Z'
        fill='currentColor'
      />
    </svg>
  )
})

TrashIcon.displayName = 'TrashIcon'
